"use client";
import {
  createDisclosureStore
} from "./KDSZSVV5.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
